import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { SubjectOrGroup } from "../../../../components/common/line-chart/line-chart-subject-dropdown";
import { TrafficLineChart } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.component";
import {
  TrafficSubject,
  makeNamedOption,
} from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.helpers";
import { PortServicesPanel } from "../../../../components/subscription-detail/port-services-panel/port-services-panel";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { ServiceSpeedPipe } from "../../../../helpers/service-speed-pipe/service-speed-pipe";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { AggspSubscriptionDetails } from "../../types";
import { LinkMemberSubscriptions } from "../link-member-subscriptions/link-member-subscriptions";
import { SubscriptionViewBase } from "../subscription-view-base";
import { PortShortcutMenu } from "./components/port-shortcut-menu/port-shortcut-menu";

@Component({
  selector: "aggsp-subscription-view",
  templateUrl: "aggsp-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    LinkMemberSubscriptions,
    PortShortcutMenu,
    RouterModule,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    PortServicesPanel,
    SubscriptionDetailHeader,
    ThirdPartyServiceIdsRowContentComponent,
    TrafficLineChart,
    TranslatePipe,
  ],
})
export class AggspSubscriptionViewComponent extends SubscriptionViewBase<AggspSubscriptionDetails> {
  protected domain = computed(() => this.subscription().domain);
  protected linkMemberSubscriptions = computed(() => this.subscription().linkMemberSubscriptions);
  protected portMode = computed(() => this.subscription().portMode);
  protected portSpeed = computed(() => this.subscription().portSpeed);
  protected address = computed(() => this.subscription().address);

  private translate = inject(TranslateService);
  protected chartSubjects = computed<SubjectOrGroup<TrafficSubject>[]>(() => [
    makeAllServicesOption(this.subscription().subscriptionId, this.translate),
    {
      name: this.translate.instant("Chart.Label.LinkMembers") as unknown as string,
      subjects: [...this.subscription().linkMemberSubscriptions.map(makeNamedOption)],
    },
    {
      name: this.translate.instant("Chart.Label.Services") as unknown as string,
      subjects: (this.subscription().services ?? []).map(makeNamedOption),
    },
  ]);
}

export function makeAllServicesOption(subscriptionId: string, translate: TranslateService) {
  return {
    subscriptionId,
    name: translate.instant("Chart.AllLinkmembers") as unknown as string,
  };
}
